<template>
<div>
    <Header />
    <main>
        <section class="bg-secondary position-relative overflow-hidden pt-xl-8">
            <div class="container inner-container position-relative pt-4 pt-sm-5">
                <h1 class="fw-bold text-center mb-2">{{ $t('welcome') }} <span class="hand-wave-animate">🖐️</span></h1>
                <h2 class="fs-1 text-center">{{ $t('explore') }}</h2>

                <!-- Barre de recherche -->
                <div class="col-md-8 mx-auto bg-body shadow-primary rounded-pill position-relative z-index-2 p-1 mt-5">
                    <form class="input-group align-items-center">
                        <input v-model="searchQuery" @input="fetchArticles" class="form-control bg-transparent border-0 me-1" type="text" :placeholder="$t('searchPlaceholder')" />
                        <button type="button" class="btn btn-dark btn-round rounded-circle lh-1 mb-0 me-2">
                            <i class="bi bi-search"></i>
                        </button>
                    </form>
                </div>
            </div>
        </section>

        <!-- Articles Section -->
        <section class="bg-secondary overflow-hidden pt-0">
            <div class="container inner-container">
                <div class="row g-4 g-lg-6">
                    <!-- Affichage des articles -->
                    <!-- Affichage des articles -->
                    <div class="col-md-6" v-for="article in articles" :key="article.id">
                        <article class="card card-img-scale bg-transparent overflow-hidden h-100 p-0">
                            <div class="d-flex gap-2 position-absolute top-0 start-0 z-index-2 m-4">
                                <span class="badge bg-dark">{{ article.category }}</span>
                                <span class="badge bg-white text-dark">{{ formatDate(article.created_at) }}</span>
                            </div>
                            <div class="card-img-scale-wrapper rounded-4">
                                <img :src="BACK_URL + article.cover" class="rounded-4 img-scale" :alt="article.title">
                            </div>
                            <div class="card-body px-2">
                                <h6 class="card-title mb-2">
                                    <a href="#">{{ article.title }}</a>
                                </h6>
                                <a class="icon-link icon-link-hover stretched-link" :href="`/blogs/articles/${article.id}/${generateSlug(article.title)}`">
                                    {{ $t('readMore') }}<i class="bi bi-arrow-right"></i>
                                </a>
                            </div>
                        </article>
                    </div>

                    <!-- Message si aucun article n'est trouvé -->
                    <div v-if="!loading && articles.length === 0" class="text-center py-5">
                        <p class="fw-bold">{{ $t('noArticlesFound') }}</p>
                    </div>

                    <!-- Pagination -->
                    <div class="col-12">
                        <nav aria-label="Page navigation">
                            <ul class="pagination pagination-primary-grad d-flex justify-content-center">
                                <li class="page-item" v-if="pagination.current_page > 1">
                                    <a @click="changePage(pagination.current_page - 1)" class="page-link">
                                        <i class="bi bi-chevron-left mx-n1 rtl-flip"></i>
                                    </a>
                                </li>
                                <li class="page-item" v-for="page in pagination.pages" :key="page" :class="{ active: pagination.current_page === page }">
                                    <a @click="changePage(page)" class="page-link">{{ page }}</a>
                                </li>
                                <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                    <a @click="changePage(pagination.current_page + 1)" class="page-link" aria-label="Next page">
                                        <i class="bi bi-chevron-right mx-n1 rtl-flip"></i>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>

        <div v-if="loading" class="loader-overlay">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ $t('loading') }}</span>
            </div>
        </div>
    </main>
    <Footer />
</div>
</template>

    
    
<script>
import axios from "@/api/axios.js";
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import {
    BACK_URL
} from "@/article_cover.js";

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            articles: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                pages: []
            },
            searchQuery: "", // 🔥 Ajout du champ pour la recherche
            loading: false,
            BACK_URL,
        };
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },

        changePage(page) {
            this.pagination.current_page = page;
            this.fetchArticles();
        },

        fetchArticles() {
            this.loading = true;

            const params = new URLSearchParams();
            params.append("page", this.pagination.current_page);
            if (this.searchQuery) {
                params.append("title", this.searchQuery);
            }

            // Ajoute la langue provenant du localStorage à la requête
            const lang = localStorage.getItem('lang') || 'en'; 
            params.append("language", lang);

            axios.get(`/get-articles-search?${params.toString()}`)
                .then(response => {
                    this.articles = response.data.data;
                    this.pagination.last_page = response.data.last_page;
                    this.pagination.pages = Array.from({
                        length: this.pagination.last_page
                    }, (_, i) => i + 1);
                })
                .catch(error => {
                    console.error('Error fetching articles:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        generateSlug(title) {
            return title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        },
    },
    mounted() {
        this.fetchArticles();
    }
};
</script>

    
    
<style scoped>
.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>